/*
 * Public API Surface of @onrsr/ui/core
 * Models, base classes, core services, utilities, directives
 */

// Models
export type { IPagedRequest, ISearchablePagedRequest, ISortablePagedRequest } from './models/paged-request';
export { PagedRequest, SearchablePagedRequest, SortablePagedRequest } from './models/paged-request';
export type { PagedResult } from './models/paged-result';
export type { LayoutConfig } from './models/layout-config.interface';

// Injection tokens
export { API_HOST } from './services/api-host.token';

// Services
export { BaseApiService } from './services/base-api.service';
export { BreadcrumbService } from './services/breadcrumb.service';
export type { BreadcrumbItem } from './services/breadcrumb.service';
export { ConfirmPopupService } from './services/confirm-popup.service';
export type { ConfirmPopupType, ConfirmPopupConfig, ConfirmPopupState, ConfirmPopupHost } from './services/confirm-popup.service';
export { NotificationService } from './services/notification.service';
export type { NotificationSeverity, NotificationPosition, NotificationOptions } from './services/notification.service';
export { LayoutService } from './services/layout.service';
export type { RhsPanelState } from './services/layout.service';

// Base classes
export { BasePage } from './base-page';

// Utilities
export { DateUtils } from './utils/date.utils';
export { mediaQuerySignal } from './utils/media-query';

// Directives
export { ClickStopPropagation } from './directives/click-stop-propagation';

// Application providers
export { provideOnrsrUi, provideOnrsrToastConfig } from './provide-onrsr-ui';
